import { Map } from 'immutable'
import { UPDATE_LINKS_SORTING } from '../action-types'
import { SIGN_OUT_SUCCESS } from 'modules/auth/action-types'
import { CURRENT_QUEUE_CHANGED } from 'modules/queues/action-types'
import { SET_CURRENT_SITE } from 'modules/sites/action-types'

const defaultSortState = new Map({ sortBy: 'index', sortDirecting: 'ASC' })

export default (state = defaultSortState, { type, payload }) => {
  switch (type) {
    case UPDATE_LINKS_SORTING:
      return state.merge(payload)

    case SIGN_OUT_SUCCESS:
    case CURRENT_QUEUE_CHANGED:
    case SET_CURRENT_SITE:
      return defaultSortState

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/links/reducers/sorting.js